var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 278 112",
    style: {
      enableBackground: "new 0 0 278 112"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.3,61.2C63.8,52,75.5,43.8,91.3,43c-0.8,2.9-1.5,5.4-2.3,7.9c0.2,0.1,0.4,0.2,0.6,0.3 c2-3.6,3.9-7.3,5.9-11C83.8,37.4,56.7,50.8,52.3,61.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,36.7c1.5-1,18.6-10.2,26.5-14.2c0.9-0.4,2.3-0.6,3.2-0.2c8.4,4.2,25.7,13.5,26.3,14.1 c-1.3-0.1-13.6,6.1-12.6,10.6c0.1,0.9-1.4,2.6-2.4,2.9c-8.4,2.3-16.8,2.2-25.2,0.1c-1-0.3-2.6-1.8-2.5-2.6C33.1,42,25,38,19,36.7  M34.1,44.6h26.5c0-0.8,0-5.7-0.5-6.3C59.4,35.4,34.8,36,34.5,38C34.3,38.2,34.1,44.6,34.1,44.6 M60.6,48 c-6.7-2.8-21.8-2.7-26.1,0.1C43.2,49.9,51.5,50,60.6,48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,61.4C31.8,52.2,20,44,4.2,43.1c0.8,2.9,1.5,5.4,2.3,7.9c-0.2,0.1-0.4,0.2-0.6,0.3C4,47.7,2,44.1,0,40.3 C11.7,37.6,38.8,51,43.2,61.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,60.3c-8.6-3.8-17.4-6.8-26.6-8.2c-2.2-0.4-2.4-1.8-2.4-3.9C18.6,50.4,28.2,54.5,37.1,60.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.3,60.7c9.1-6.1,18.9-10.2,29.7-12.6c0.1,2.2-0.3,3.6-2.7,4C74.9,53.6,65.9,56.7,57.3,60.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,59.3c1.6,0,3.2-0.1,4.7-0.1c1.4,0,1.8,0.6,1.1,1.8c-1.5,2.8-3,5.7-4.6,8.5c-0.6,1-1.3,1.1-2,0.1 c-1.7-2.8-3.5-5.5-5.1-8.3c-0.6-1.1-0.3-1.7,1-1.8C44.2,59.4,45.8,59.3,47.4,59.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,76.5h3.9l3.1,5.1l3.1-5.1h3.9v13.2h-3.6v-7.6l-3.4,5.2h-0.1l-3.3-5.1v7.5H9.7V76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,84.6L25.4,84.6c0-2.9,2.4-5.4,5.6-5.4c3.3,0,5.6,2.4,5.6,5.3v0c0,2.9-2.4,5.3-5.6,5.3 C27.8,89.9,25.4,87.5,25.4,84.6z M33.2,84.6L33.2,84.6c0-1.3-0.9-2.3-2.2-2.3c-1.3,0-2.1,1-2.1,2.3v0c0,1.2,0.9,2.3,2.2,2.3 C32.4,86.9,33.2,85.9,33.2,84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.2,79.5h3.6v1.4c0.7-0.8,1.6-1.6,3-1.6c1.4,0,2.4,0.6,2.9,1.7c0.9-1,1.9-1.7,3.4-1.7 c2.2,0,3.5,1.4,3.5,3.7v6.7H51v-5.5c0-1.1-0.5-1.7-1.4-1.7c-0.8,0-1.5,0.6-1.5,1.7v5.5h-3.6v-5.5c0-1.1-0.5-1.7-1.4-1.7 c-0.8,0-1.4,0.6-1.4,1.7v5.5h-3.6V79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,86.5v-4.1h-1.2v-2.9h1.2v-2.6h3.6v2.6H63v2.9h-2.4v3.4c0,0.7,0.3,1,1,1c0.5,0,0.9-0.1,1.4-0.3v2.8 c-0.6,0.4-1.5,0.6-2.5,0.6C58.3,89.9,57.1,88.9,57.1,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,86.8L64,86.8c0-2.1,1.6-3.2,4-3.2c0.9,0,1.9,0.2,2.4,0.4v-0.2c0-1.1-0.7-1.7-2-1.7 c-1.1,0-1.9,0.2-2.8,0.6l-0.7-2.5c1.1-0.5,2.4-0.8,4.1-0.8c1.8,0,3.1,0.4,3.9,1.2c0.8,0.8,1.1,1.8,1.1,3.2v5.9h-3.5v-1.1 c-0.7,0.8-1.7,1.3-3,1.3C65.5,89.9,64,88.8,64,86.8z M70.5,86v-0.5c-0.4-0.2-0.9-0.3-1.4-0.3c-1,0-1.6,0.5-1.6,1.3v0 c0,0.7,0.5,1.1,1.3,1.1C69.8,87.7,70.5,87,70.5,86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,87.3l4.7-5h-4.5v-2.8h9.3v2.4l-4.7,5h4.7v2.8h-9.4V87.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.e7f3a287830114cbc1e7beb244105790.svg";
export { ForwardRef as ReactComponent };